import { usePosthog } from '@shared/plugins/posthog'
import type { Turn } from '../types'

export const QUESTION_EVENT = 'ai_question_answered'

/* one PostHog event per question; the prompt and the answer are merchant data and are never sent */
export const trackQuestion = (tenantId: string, turn: Turn): void => {
  const success = turn.status === 'done'
  usePosthog().capture(QUESTION_EVENT, {
    merchant_id: tenantId,
    success,
    ...(success ? {} : { failure_reason: turn.error?.code || 'TURN_FAILED' }),
    response_time_ms: (turn.finishedAt ?? Date.now()) - turn.startedAt
  })
}
